/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useHistory, useLocation } from 'react-router-dom';
import BtnPrincipal from 'src/components/Buttons/BtnPrincipal';
import Timer from 'src/components/Counter';
import { DIV } from 'src/components/CustomStyledComponents';
import HeaderPage from 'src/components/header/HeaderPage';
import NavbarHeader from 'src/components/header/NavbarHeader';
import InfoPtp from 'src/components/InfoPtp';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import withCotizacion from 'src/HOC/withCotizacion';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import usePtp from 'src/hooks/usePtp';
import useQueryString from 'src/hooks/useQueryString';
import { guardarLead } from 'src/services';

const PtpPagoUnico = ({ idCotizacion, cotizacion }) => {
  const history = useHistory();
  // const location=useLocation();

  const { addErrorToast, addInfoToast, addSuccessToast, addWarningToast } = useCustomToast();
  const { estado } = useQueryString();
  const { values, setSecundario, resetLoading } = useLoading(true);
  const { consultarEstadoPago, ESTADOS_PAGO } = usePtp();
  const [estadoPago, setEstadoPago] = useState('');
  const [estadoPago2, setEstadoPago2] = useState({});
  const [verificandoEstado, setVerificandoEstado] = useState(false);

  const init = useCallback(async () => {
    setSecundario('Estamos verificando tu pago...');
    guardarLead(idCotizacion, 'P2P_PAGO_UNICO_INGRESO');
    guardarLead(idCotizacion, `P2P_PAGO_UNICO_ESTADO_${estado}`);
    const traEstado = await consultarEstadoPago();
    const params = new URL(document.location.href).searchParams;

    if (traEstado.hasError) {
      setEstadoPago2({ pago_id: params.get('idPago') });
    } else {
      setEstadoPago2({ pago_id: traEstado?.data?.pago_id });
    }

    console.log('??????? ', traEstado);
    switch (traEstado.estado) {
      case ESTADOS_PAGO.SIN_PAGOS_PENDIENTES:
      case 'APROBADO':
        setEstadoPago(ESTADOS_PAGO.APROBADO);
        addSuccessToast(`Pago aprobado, Ref:${params.get('idPago')}`, {
          autoDismiss: false,
        });
        // history.push(`/ingresarPoliza/${idCotizacion}`);
        redireccionar();
        break;
      case 'PENDIENTE':
        addInfoToast(
          'Su pago está siendo procesado, pronto te llegará un mensaje a tu correo para que puedas continuar tu compra',
          {
            autoDismiss: false,
          },
        );
        setEstadoPago(ESTADOS_PAGO.PENDIENTE);
        resetLoading();
        break;
      case 'RECHAZADO':
        setEstadoPago(ESTADOS_PAGO.RECHAZADO);

        addErrorToast(`Tu petición de pago ha sido rechazada, Ref:${params.get('idPago')}`, {
          autoDismiss: false,
        });
        history.push({ pathname: `/paginaPago/${idCotizacion}`, state: params.get('idPago') });
        resetLoading();
        break;

      default:
        addWarningToast('Ha ocurrido un problema al consultar el estado del pago', {
          autoDismiss: false,
        });
        resetLoading();
        break;
    }
  }, []);

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    let bucle = null;
    console.log('?????? inicio', estadoPago);
    const params = new URL(document.location.href).searchParams;
    if (estadoPago === ESTADOS_PAGO.PENDIENTE) {
      console.log('?????? iicio blucle ', estadoPago);
      bucle = setInterval(async () => {
        setVerificandoEstado(true);
        const traEstado = await consultarEstadoPago();
        if (traEstado?.hasError) {
          addWarningToast('Ha ocurrido un problema al verificar el estado de su pago', {
            autoDismiss: false,
          });
        } else {
          if (traEstado.estado === ESTADOS_PAGO.APROBADO) {
            clearInterval(bucle);
            addSuccessToast(`Transacción aprobada \nRef: ${params.get('idPago')}`)
            // history.push(`/ingresarPoliza/${idCotizacion}`);
            redireccionar();
          } else if (traEstado.estado === ESTADOS_PAGO.RECHAZADO) {
            addErrorToast(`Tu petición de pago ha sido rechazada, Ref:${params.get('idPago')}`, {
              autoDismiss: false,
            });
            history.push({ pathname: `/paginaPago/${idCotizacion}`, state: params.get('idPago') });
          }
        }
        setVerificandoEstado(false);
      }, 60000);
    }

    return () => {
      clearInterval(bucle);
    };
  }, [estadoPago]);

  //funcion para redireccionar
  const redireccionar = () => {
    if (`${cotizacion.producto.tieneFirma}` === '1') {
      switch (cotizacion.medioFirma) {
        case 'evicertia':
          return history.push(`/firmarCertificado/${idCotizacion}`);
        case 'token':
          return history.push(`/verificarTokenPago/${idCotizacion}/${idCotizacion}`);
        case 'fisica':
          return history.push(`/ingresarPoliza/${idCotizacion}/`);
        default:
          // addErrorToast('Cotizacion no tiene el medio para la firma', { autoDismiss: false });
          break;
      }
    } else {
      return history.push(`/ingresarPoliza/${idCotizacion}/`);
    }
  };

  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="pagoPlaceToPay.globalStyles" className="container-fluid container-page">
        <NavbarHeader showBack={false} />
        <HeaderPage progreso={80} />

        <div className="row justify-content-center">
          <div className="col-11 col-md-7 mt-3">
            <h4 className="titulo font-weight-bold">Estado de pago</h4>
            <p className="descripcion">
              Tu pago se encuentra en estado <strong>PENDIENTE </strong>
              pronto te llegara un correo a <strong>{cotizacion?.titular?.email}</strong> para que
              puedas continuar con tu compra
            </p>
          </div>
        </div>

        {console.log('AAAAA:')}

        <InfoPtp
          valor={cotizacion?.valoresPagar?.total}
          resultado={estado}
          referencia={idCotizacion}
          pago={estadoPago2}
          label="Valor a pagar"
          periocidadPago={`Pago ${cotizacion?.producto?.periocidadPago}`}
        >
          <React.Fragment>
            <div className="col-12" />
            {estadoPago === ESTADOS_PAGO.PENDIENTE && !verificandoEstado && (
              <div className="col-10 col-sm-8 col-md-7 col-xl-4 mt-5">
                <h5 className="label__pendiente font-weight-bold text-secondary text-justify">
                  Al parecer el proceso de verificación está tardando más de lo esperado, pronto
                  seras notificado a tu correo{' '}
                  {cotizacion.titular.email}
                </h5>

                <h5 className="label__timer mt-3">
                  Se volvera a consultar en{' '}
                  <Timer
                    initialTime={60000}
                    //initialTime={5000}
                    direction="backward"
                    //onFinish={() => setTimeFinished(true)}
                  />
                  segundos
                </h5>
              </div>
            )}
            <div className="col-12" />
            {
              <div className="col-10 col-sm-8 col-md-7 col-xl-4">
                {verificandoEstado && (
                  <ProgressBar
                    className="progresbar__pendiente my-5"
                    animated
                    now={100}
                    label="Verificando estado..."
                  />
                )}
              </div>
            }
            <div className="col-12 text-center" >
              <BtnPrincipal
                label="Mis pagos"
                onClick={() => history.push(`/listado-pago/${idCotizacion}/${cotizacion.empPtp}`)}
              />
            </div>
          </React.Fragment>
        </InfoPtp>
      </DIV>
    </LoadingWrapper>
  );
};

export default withCotizacion(PtpPagoUnico);
